import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import logoUrl from '../lendnation-logo-v2.svg';

class Logo extends Component {
  render() {
    return (
      <footer className="apply-now-footer">
        <Row>
          <Col lg="3" sm="4" xs="6">
            <img
              src={logoUrl}
              alt="CashMax"
              className="img-responsive logo-img"
            />
          </Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
        </Row>
      </footer>
    );
  }
}
export default Logo;
